import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const CALENDLY_URL = 'https://paystack.com/buy/private-clarity-call-sdonrr';

export default function FinalCtaSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        contentRef.current,
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 70%',
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative bg-[#6B1E3B] py-16 md:py-28 lg:py-32 overflow-hidden"
    >
      {/* Background Image at low opacity */}
      <div className="absolute inset-0 bg-[#6B1E3B]">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20editorial%20portrait%20of%20a%20woman%20standing%20in%20warm%20golden%20light%20silhouette%20mood%20dramatic%20low-key%20photography%20rich%20dark%20background%20empowering%20feminine%20energy%20film%20grain%20texture%20healing%20and%20transformation%20atmosphere%20soft%20shadow%20portrait&width=1600&height=800&seq=final-cta-01&orientation=landscape"
          alt=""
          className="w-full h-full object-contain object-center opacity-20"
          width="1600"
          height="800"
        />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-4xl mx-auto text-center">
        <div ref={contentRef}>
          <h2 className="font-heading text-xl md:text-3xl lg:text-5xl leading-[1.15] text-[#FDFAF8] mb-10">
            The woman you are becoming
            <br />
            is already waiting.
            <br />
            The only thing left
            <br />
            is the decision.
          </h2>

          <a
            href={CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-4 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300 whitespace-nowrap mb-4 w-full sm:w-auto"
          >
  Book Your Clarity Call
</a>
<p className="text-xs text-[#D0C0C8] text-center mt-2">
  <a href="https://paystack.com/buy/private-clarity-call-sdonrr" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#C9A84C]">Book a Private Clarity Call</a>
</p>
        </div>
      </div>
    </section>
  );
}